/// \file adminNotifications.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import {lazy, Suspense} from "react";
import { ActionFunctionArgs, LoaderFunctionArgs, Route } from "react-router-dom";

const AdminNotificationsList = lazy(() => import('../views/admin-notifications/list/view'));

async function adminNotificationsDataLoader(args: LoaderFunctionArgs) {
  const actualLoader = (await import('../views/admin-notifications/list/loader')).default;
  return actualLoader(args);
}

export async function adminNotificationsAction(args: ActionFunctionArgs) {
  const actualAction = (await import("../views/admin-notifications/list/action")).action;
  return actualAction(args);
}

const routes = (
  <Route
    path="adminNotifications"
    handle={{
      text:"NOTIFICATIONS"
    }}
  >
    <Route
      index
      element={
        <Suspense fallback={<div>Loading...</div>}>
          <AdminNotificationsList />
        </Suspense>
      }
      loader={adminNotificationsDataLoader}
      action={adminNotificationsAction}
      />
  </Route>
);

export default routes;